import React from "react";

/**
 * PollingIndicator - Indicador de última actualización con estado stale.
 *
 * Props:
 * - lastUpdated: string|Date|null - Timestamp de última actualización exitosa
 * - isStale: boolean - True cuando los datos podrían no estar actualizados
 * - onRefresh: () => void (optional) - Callback para forzar actualización
 */
export function PollingIndicator({ lastUpdated, isStale, onRefresh }) {
  const formatTimestamp = (ts) => {
    if (!ts) return null;
    const date = ts instanceof Date ? ts : new Date(ts);
    if (isNaN(date.getTime())) return null;
    return date.toLocaleString("es-CR", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  const formatted = formatTimestamp(lastUpdated);

  return (
    <div
      className={`inline-flex items-center gap-2 text-xs px-3 py-1.5 rounded-full ${
        isStale
          ? "bg-yellow-50 text-yellow-700 border border-yellow-200"
          : "bg-gray-50 text-gray-500 border border-gray-200"
      }`}
    >
      {isStale && (
        <svg
          className="w-3.5 h-3.5 text-yellow-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-2.694-.833-3.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z"
          />
        </svg>
      )}
      {!isStale && (
        <svg
          className="w-3.5 h-3.5 text-green-500"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <circle cx="12" cy="12" r="4" />
        </svg>
      )}
      <span>
        {formatted
          ? `Última actualización: ${formatted}`
          : "Cargando datos..."}
      </span>
      {isStale && (
        <span className="text-yellow-600 font-medium">
          (datos podrían no estar actualizados)
        </span>
      )}
      {onRefresh && (
        <button
          type="button"
          onClick={onRefresh}
          className="ml-1 text-gray-500 hover:text-gray-700"
          title="Actualizar ahora"
        >
          <svg
            className="w-3.5 h-3.5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            />
          </svg>
        </button>
      )}
    </div>
  );
}

export default PollingIndicator;
